import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookMessengerIcon,
  FacebookMessengerShareButton,
  FacebookShareButton,
  HatenaIcon,
  HatenaShareButton,
  InstapaperIcon,
  InstapaperShareButton,
  LineIcon,
  LineShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  LivejournalIcon,
  LivejournalShareButton,
  MailruIcon,
  MailruShareButton,
  OKIcon,
  OKShareButton,
  PinterestIcon,
  PinterestShareButton,
  PocketIcon,
  PocketShareButton,
  RedditIcon,
  RedditShareButton,
  TelegramIcon,
  TelegramShareButton,
  TumblrIcon,
  TumblrShareButton,
  TwitterShareButton,
  ViberIcon,
  ViberShareButton,
  VKIcon,
  VKShareButton,
  WeiboIcon,
  WeiboShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  WorkplaceIcon,
  WorkplaceShareButton,
  XIcon,
} from 'react-share'

import { InstagramIcon, SocialButton, SpotifyIcon } from '../common/socials'

const config: any = {
  facebook: { component: FacebookShareButton, icon: FacebookIcon },
  messenger: {
    component: FacebookMessengerShareButton,
    icon: FacebookMessengerIcon,
  },
  twitter: { component: TwitterShareButton, icon: XIcon },
  linkedin: { component: LinkedinShareButton, icon: LinkedinIcon },
  pinterest: { component: PinterestShareButton, icon: PinterestIcon },
  vk: { component: VKShareButton, icon: VKIcon },
  ok: { component: OKShareButton, icon: OKIcon },
  telegram: { component: TelegramShareButton, icon: TelegramIcon },
  whatsapp: { component: WhatsappShareButton, icon: WhatsappIcon },
  reddit: { component: RedditShareButton, icon: RedditIcon },
  tumblr: { component: TumblrShareButton, icon: TumblrIcon },
  mailru: { component: MailruShareButton, icon: MailruIcon },
  email: { component: EmailShareButton, icon: EmailIcon },
  livejournal: { component: LivejournalShareButton, icon: LivejournalIcon },
  viber: { component: ViberShareButton, icon: ViberIcon },
  workplace: { component: WorkplaceShareButton, icon: WorkplaceIcon },
  line: { component: LineShareButton, icon: LineIcon },
  pocket: { component: PocketShareButton, icon: PocketIcon },
  instapaper: { component: InstapaperShareButton, icon: InstapaperIcon },
  weibo: { component: WeiboShareButton, icon: WeiboIcon },
  hatena: { component: HatenaShareButton, icon: HatenaIcon },
  instagram: { component: SocialButton, icon: InstagramIcon },
  spotify: { component: SocialButton, icon: SpotifyIcon },
}

export default function (key: string) {
  return config[key]
}
